// extracted by mini-css-extract-plugin
export default {"primaryFont":"\"Roboto\",sans-serif"};